/**
 * Mixpanel Initialization
 * Initializes Mixpanel analytics or provides mock functions in development
 */

import config from "./config";

export function registerMixpanel() {
  // In development mode, use mock Mixpanel
  if (config.isDevelopment()) {
    window.mixpanel = {
      track: function () {
        console.log("Mixpanel (mock) track:", arguments);
      },
      register: function () {
        console.log("Mixpanel (mock) register:", arguments);
      },
      identify: function () {
        console.log("Mixpanel (mock) identify:", arguments);
      },
      people: {
        set: function () {
          console.log("Mixpanel (mock) people.set:", arguments);
        }
      }
    };
    console.log("Mixpanel initialized in mock mode");
    return;
  }

  // Production Mixpanel initialization
  if (!config.mixpanelAppId) {
    console.warn("MIXPANEL_APP_ID not configured");
    window.mixpanel = {
      track: function () {},
      register: function () {},
      identify: function () {},
      people: { set: function () {} }
    };
    return;
  }

  // Mixpanel initialization code
  (function(e, a) {
    if (!a.__SV) {
      var b = window;
      try {
        var c, l, i, j = b.location, g = j.hash;
        c = function(a, b) { return (l = a.match(RegExp(b + "=([^&]*)"))) ? l[1] : null; };
        g && c(g, "state") && (i = JSON.parse(decodeURIComponent(c(g, "state"))), "mpeditor" === i.action && (b.sessionStorage.setItem("_mpcehash", g), history.replaceState(i.desiredHash || "", e.title, j.pathname + j.search)));
      } catch (m) {}
      var k, h;
      window.mixpanel = a;
      a._i = [];
      a.init = function(b, c, f) {
        function e(b, a) {
          var c = a.split(".");
          2 == c.length && (b = b[c[0]], a = c[1]);
          b[a] = function() {
            b.push([a].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var d = a;
        "undefined" !== typeof f ? d = a[f] = [] : f = "mixpanel";
        d.people = d.people || [];
        d.toString = function(b) {
          var a = "mixpanel";
          "mixpanel" !== f && (a += "." + f);
          b || (a += " (stub)");
          return a;
        };
        d.people.toString = function() {
          return d.toString(1) + ".people (stub)";
        };
        k = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
        for (h = 0; h < k.length; h++) e(d, k[h]);
        a._i.push([b, c, f]);
      };
      a.__SV = 1.2;
      b = e.createElement("script");
      b.type = "text/javascript";
      b.async = !0;
      b.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === e.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
      c = e.getElementsByTagName("script")[0];
      c.parentNode.insertBefore(b, c);
    }
  })(document, window.mixpanel || []);
  
  mixpanel.init(config.mixpanelAppId);
  console.log("Mixpanel initialized with ID:", config.mixpanelAppId);
}

// Get PLACE_SLUG from URL parameters
export function getPlaceSlug() {
  const urlParams = new URLSearchParams(window.location.search);
  const place = urlParams.get("place") || "";
  // Sanitize place slug - only allow alphanumeric and hyphens
  return place.replace(/[^-0-9a-z]/g, "");
}

// Set global PLACE_SLUG variable for compatibility
window.PLACE_SLUG = getPlaceSlug();

